import React, { useEffect, useState } from "react";
import "./Charts.scss";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Title,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import moment from "moment-jalaali";
import { apiFetch } from "../../api/client";

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Title,
  Legend
);

const MiniChart = ({ data, type }) => {
  const [archive, setArchive] = useState([]);

  useEffect(() => {
    const getArchive = async () => {
      const res = await apiFetch("/api/archive", {
        method: "POST",
        body: JSON.stringify({
          type: type,
          id: data.id,
          limit: 10,
        }),
      });

      const resData = await res.json();
      //   console.log(resData);

      setArchive(resData.archive.reverse());
    };

    getArchive();
  }, [type, data.id]);

  const chartData = {
    labels: archive.map((item) =>
      moment(item.createdAt).format("HH:mm jMM/jDD")
    ),
    datasets: [
      //   {
      //     label: "Buy Price",
      //     data: archive.map(item => item.buyPrice),
      //     borderColor: "#FF4500",
      //     backgroundColor: "rgba(255, 69, 0, 0.5)",
      //     tension: 0.4,
      //   },
      {
        label: "نرخ فروش",
        data: archive.map((item) => item.sellPrice),
        borderColor: data?.sellPrice > data?.pSellPrice ? "#91A600" : "#DE764B",
        backgroundColor:
          data?.sellPrice > data?.pSellPrice ? "#BAE066" : "#F5AD90",
        tension: 0.4,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        position: "top",
      },
      //   title: {
      //     display: true,
      //     text: "Price History",
      //   },
    },
    scales: {
      x: {
        type: "category",
        ticks: {
          font: {
            size: 8, // Adjust the font size for the X-axis labels
          },
          color: "#666", // Optional: Set the font color
        },
        // title: {
        //   display: true,
        //   text: "Time",
        // },
      },
      y: {
        type: "linear",
        ticks: {
          font: {
            size: 8, // Adjust the font size for the Y-axis labels
          },
          color: "#666", // Optional: Set the font color
        },
        // title: {
        //   display: true,
        //   text: "Price",
        // },
      },
    },
  };

  return (
    <div className="mini-chart-container">
      <Line data={chartData} options={chartOptions} className="chart-canvas" />
    </div>
  );
};

export default MiniChart;
